import { Column } from '@codeparva/ui-components-library';
import React from 'react';
import { weakKey } from '../../../../utilities/weakKey';
import { UnitCardTypes } from '../../UnitCardTypes';

export const AmenitiesComponent = ({
  amenitiesList,
  amenitiesHeading,
}: UnitCardTypes.TAmenitiesSection) => {
  return amenitiesList && amenitiesList.length > 0 ? (
    <div className="amenitiesSection">
      <p className="amenitiesTitle">{amenitiesHeading}</p>
      <Column className="amenitiesList">
        {amenitiesList.map((amenity: { amenity_text: string }) => (
          <div className="is-flex amenityContainer" key={weakKey(amenity)}>
            <li className="amenityList">{amenity.amenity_text}</li>
          </div>
        ))}
      </Column>
    </div>
  ) : (
    <></>
  );
};
